import React from "react"
import { connectSearchBox } from "react-instantsearch-dom"
import { SearchBoxProvided, SearchBoxExposed } from "react-instantsearch-core"
import { makeStyles } from "makeStyles"
import { FormControl, InputAdornment, OutlinedInput, IconButton } from "@mui/material"
import Icon from "@mdi/react"
import { mdiMagnify } from "@mdi/js"

const useStyles = makeStyles()({
	textField: {
		width: "100%",
		margin: "auto",
		background: "white",
		borderRadius: 20,
		outline: 0,
		maxWidth: 550,
	},
	"@media only screen and (min-width: 960px) and (max-width: 1150px)": {
		textField: {
			width: "100%",
			maxWidth: 400,
			margin: "auto",
			background: "white",
			borderRadius: 6,
			fontSize: 13,
		},
	},
	inputStyle: {
		fontSize: 13,
		borderRadius: 50,
		height: 44,
	},
	"@media only screen and (max-width: 1150px)": {
		inputStyle: {
			fontSize: 13,
			borderRadius: 50,
			paddingTop: 0,
			paddingBottom: 4,
		},
	},
	// mobile-tablet
	"@media only screen and (min-width: 960px)": {
		textField: {
			maxWidth: 550,
		},
	},
	"@media only screen and (max-width: 960px)": {
		textField: {
			borderRadius: 20,
		},
		inputStyle: {
			fontSize: 13,
			borderRadius: 20,
			paddingTop: 3,
		},
	},
})

const SearchBoxInput = ({
	onSubmit,
	searchQuery,
	setSearchQuery,
	toggleHeader,
}: Props & SearchBoxProvided) => {
	const { classes } = useStyles()

	const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { value } = e.target
		setSearchQuery(value)
	}

	const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { keyCode, which } = e
		if (keyCode === 13 || which === 13) onSubmit()
	}

	return (
		<FormControl className={classes.textField} variant="filled">
			<OutlinedInput
				id="search-box"
				endAdornment={
					<InputAdornment position="end">
						<IconButton onClick={onSubmit} size="large">
							<Icon path={mdiMagnify} size={1} color="#4691CE" />
						</IconButton>
					</InputAdornment>
				}
				onChange={onChange}
				onClick={toggleHeader}
				value={searchQuery}
				inputProps={{ onKeyPress }}
				placeholder="Nach Produkten suchen"
				className={classes.inputStyle}
			/>
		</FormControl>
	)
}
interface Props {
	onSubmit: () => void
	searchQuery: string
	setSearchQuery: (searchQuery: string) => void
	toggleHeader: () => void
}

const ExposedSearchBoxInput: React.ComponentClass<Props & SearchBoxExposed> =
	connectSearchBox(SearchBoxInput)

export default ExposedSearchBoxInput
